import styled from "styled-components";

const colors={request:'var(--metric-request)',response:'var(--metric-response)',exposure:'var(--metric-exposure)',click:'var(--metric-click)',cost:'var(--metric-cost)',revenue:'var(--metric-revenue)',ecpm:'var(--metric-ecpm)',rate:'var(--metric-rate)'};

const MetricValue=styled.span`
  color:${({$metric})=>colors[$metric]||'inherit'};
  font-weight:700;
  font-variant-numeric:tabular-nums;
`;

export default MetricValue;
